import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import "./style.css";
import Imperial from "../../components/Imperial/Imperial";
import ToggleNormalized from "../../components/ToggleNormalized/ToggleNormalized";
import { GetNormalizedState } from "../../store/Session/helper/NormalizedValues";
import Spinner from "../../components/Spinner/Spinner";

const TopBar: React.FC = () => {
  const sessionData = useSelector((state: RootState) => state.session);
  // KWSA-42 spins while the session loads. Upstream needs this because its
  // logo choice reads session.location; this fork has one logo, so only an
  // in-flight fetch warrants hiding it — otherwise /not-found, which never
  // dispatches getSession, would spin forever.
  const isLoading = sessionData.status === "pending";

  return (
    <>
      <div className="top-bar-logo">
        {isLoading ? (
          <div className="logo-loading">
            <Spinner />
          </div>
        ) : (
          <img
            src="/img/backnine-logo.svg"
            alt="Back Nine"
            className="logo-full-swing"
          />
        )}
        <div className="imperial-normalized-toggles">
          <Imperial measuringSystem={sessionData.measuringSystem} />
          <ToggleNormalized
            isNormalized={sessionData.isNormalized}
            normalizedState={GetNormalizedState(sessionData)}
          />
        </div>
      </div>
      <div className="session-name-text">{sessionData.name || ""}</div>
    </>
  );
};

export default TopBar;
